import React, { ReactElement, useContext, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { AppContext } from "AppContext";

import { isNil } from "ramda";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { getServerDetails } from "redux/selectors/serversSelector";

import { IServerDetails } from "types/api/serversApiInterface";

import ClusterNameStat from "./CluserNameStat";
import MainServerStatistics from "./MainServerStatistics";

const ClusterServerStatistics = ({ servers }: { servers: Array<IServerDetails> }): ReactElement => {
 const server = useSelector(getServerDetails);

 const { socket } = useContext(AppContext);

 const [performanceData, setPerformanceData] = useState<
  Array<{ token: string; cpu: number; ram: number; disk: number }>
 >([{ token: "", cpu: 0, ram: 0, disk: 0 }]);

 useEffect(() => {
  function onServerPerformance(value: any) {
   if (value?.length > 0) {
    let tempArr = [];
    for (let i = 0; i < value.length; i++) {
     tempArr.push({
      token: value[i]?.token,
      cpu: parseInt(value[i]?.cpu),
      ram: parseInt(value[i]?.ram),
      disk: parseInt(value[i]?.disk)
     });
    }
    setPerformanceData(tempArr);
   }
  }
  !isNil(socket) && socket.on("server_logs", onServerPerformance);
  return () => {
   !isNil(socket) && socket.off("server_logs", onServerPerformance);
  };
 }, [socket]);

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2 }}>
   <Stack>
    <Typography variant="unboundedTitle" fontWeight="bold" fontSize={14} textAlign="left">
     Master
    </Typography>
    <Stack direction="row" textAlign="left" alignItems="center" spacing={4}>
     {server.cluster && <ClusterNameStat name={server.serverName} cluster={server.cluster} />}
     <Stack justifyContent="center" height={"100%"} width="stretch">
      <MainServerStatistics agentoken={server.agentoken || ""} performance={performanceData} />
     </Stack>
    </Stack>
    <Divider sx={{ mt: 1 }} />
    <Typography variant="unboundedTitle" fontWeight="bold" fontSize={14} textAlign="left">
     Nodes
    </Typography>
    <Stack spacing={2}>
     {servers.length === 0 ? (
      <Typography variant="caption" fontStyle="italic">
       <FormattedMessage id="cluster.noNodesFound" />
      </Typography>
     ) : (
      servers.map((element, index) => {
       return (
        <Stack
         direction="row"
         textAlign="left"
         alignItems="center"
         spacing={4}
         key={`node-stat-${index}`}>
         {element.cluster && (
          <ClusterNameStat name={element.server_name} cluster={element.cluster} />
         )}
         <Stack justifyContent="center" height={"100%"} width="stretch">
          <MainServerStatistics agentoken={element.agentoken || ""} performance={performanceData} />
         </Stack>
        </Stack>
       );
      })
     )}
    </Stack>
   </Stack>
  </Paper>
 );
};

export default ClusterServerStatistics;
